import { getEnglishComparePageBySlug } from "@/app/seo-compare-en";
import { CompareLayoutEn } from "./CompareLayoutEn";

export default function EnglishHotlineVsSaas() {
  const page = getEnglishComparePageBySlug("hotline-vs-saas");
  if (!page) return null;
  return <CompareLayoutEn page={page} />;
}
